import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { OrgaoJulgadorLocalFrmComponent } from '../orgao-julgador-local-frm/orgao-julgador-local-frm.component';
import { OrgaoJulgadorLocal } from '../orgao-julgador-local.model';

@Component({
  selector: 'app-orgao-julgador-local-edicao',
  templateUrl: './orgao-julgador-local-edicao.component.html',
  styleUrls: ['./orgao-julgador-local-edicao.component.css'],
})
export class OrgaoJulgadorLocalEdicaoComponent implements OnInit {
  @ViewChild(OrgaoJulgadorLocalFrmComponent, { static: true })
  frm!: OrgaoJulgadorLocalFrmComponent;

  @Output()
  public onSalvar = new EventEmitter<void>();

  display = false;

  constructor() {}

  ngOnInit(): void {}

  salvar() {
    this.frm.salvar();
  }

  onSalvarProxy(): void {
    this.display = false;
    this.onSalvar.emit();
  }

  showDialog(orgaoJulgadorLocal: OrgaoJulgadorLocal) {
    this.display = true;
    this.frm.iniciarAlteracao(orgaoJulgadorLocal);
  }

  voltar() {
    this.display = false;
  }
}
